import { render, staticRenderFns } from "./CreateAssessmentButton.vue?vue&type=template&id=081b5771&"
import script from "./CreateAssessmentButton.vue?vue&type=script&lang=js&"
export * from "./CreateAssessmentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports